import React, { Component } from "react";
import { Button, Paper } from "@material-ui/core";
import { GetWalletDetails } from "../../../../services";
import { NotificationManager } from "react-notifications";
import Loader from "../../../../loader";

export default class AdminWalletTopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: false,
      custId: "",
      amount: "",
    };
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = async () => {
    const { custId, amount } = this.state;

    if (!custId || !amount || Number(amount) <= 0) {
      NotificationManager.error(
        "Customer ID and valid amount are required",
        "Input Error",
      );
      return;
    }

    this.setState({ isLoaded: true });

    const payload = {
      custId: Number(custId),
      amount: Number(amount),
    };

    try {
      const response = await GetWalletDetails.adminWalletTopup(payload);

      this.setState({ isLoaded: false });

      if (response && response.success) {
        NotificationManager.success(
          `₹${amount} credited successfully`,
          "Wallet Updated",
        );
        this.setState({ custId: "", amount: "" });
      } else {
        NotificationManager.error(
          (response && response.message) || "Something went wrong",
          "Error",
        );
      }
    } catch (err) {
      this.setState({ isLoaded: false });
      NotificationManager.error("Server error", "Error");
    }
  };

  render() {
    const { isLoaded, custId, amount } = this.state;

    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-5 col-md-9">
            <h2 className="mt-30 page-title">Admin Wallet Topup</h2>
          </div>
          <div className="col-lg-5 col-md-3 back-btn">
            <Button variant="contained" onClick={this.handleBack}>
              <i className="fas fa-arrow-left" /> Back
            </Button>
          </div>
        </div>

        <ol className="breadcrumb mb-30">
          <li className="breadcrumb-item">Dashboard</li>
          <li className="breadcrumb-item">Wallet</li>
          <li className="breadcrumb-item active">Admin Topup</li>
        </ol>

        <Paper className="user-management" style={{ padding: "1rem" }}>
          {isLoaded && <Loader />}

          <div className="row">
            <div className="col-md-6 form-group">
              <label>Customer ID</label>
              <input
                type="number"
                className="form-control"
                name="custId"
                value={custId}
                onChange={this.handleChange}
                placeholder="Enter Customer ID"
              />
            </div>

            <div className="col-md-6 form-group">
              <label>Amount (₹)</label>
              <input
                type="number"
                className="form-control"
                name="amount"
                value={amount}
                onChange={this.handleChange}
                placeholder="Enter amount"
              />
            </div>
          </div>

          <button
            className="btn btn-primary col-sm-3 mt-3 py-2"
            onClick={this.handleSubmit}
          >
            Credit Wallet
          </button>
        </Paper>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/view/wallet/amountadd/index.js